import HeaderMono from "./ui/HeaderMono";
import IconLink from "./ui/IconLink";
import { GitHubIcon, LinkedInIcon, MailIcon } from "../icons/Icons";
import { contact, meta } from "../content";


export default function Footer() {
  return (
    <footer id="contact" className="border-t border-white/5">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <HeaderMono>{contact.heading}</HeaderMono>
        <p className="text-slate-300 mb-6">{contact.blurb}</p>
        <div className="flex flex-wrap items-center gap-4">
          <IconLink href={`mailto:${meta.email}`} label={meta.email}><MailIcon className="w-5 h-5" /></IconLink>
          <IconLink href={meta.linkedin} label="LinkedIn"><LinkedInIcon className="w-5 h-5" /></IconLink>
          <IconLink href={meta.github} label="GitHub"><GitHubIcon className="w-5 h-5" /></IconLink>
        </div>
        <p className="mt-8 text-xs text-slate-500">© {new Date().getFullYear()} {meta.shortName}. Built with React & Tailwind.</p>
      </div>
    </footer>
  );
}
